module.exports = __webpack_public_path__ + "static/media/about-startup.373e9068.svg";